// Api
import settingsApi from './api';

// Action Types
import { MAP_TYPE, FETCH_FEEDBACK_CATEGORIES, SEND_FEEDBACK } from './actionTypes';


export const updateMapType = ( mapTypeId ) => dispatch => {
  const receivedMapTypeId = mapTypeId => ({
    type: MAP_TYPE.update(),
    payload: mapTypeId
  });

  dispatch(receivedMapTypeId( mapTypeId ));
};

export const fetchFeedbackCategories = ( token ) => dispatch => {
  const requestFetchFeedbackCategories = () => ({
    type: FETCH_FEEDBACK_CATEGORIES.request()
  });

  const receivedFeedbackCategories = feedbackCategories => ({
    type: FETCH_FEEDBACK_CATEGORIES.success(),
    payload: feedbackCategories
  });

  const errorOnFetchFeedbackCategories = error => ({
    type: FETCH_FEEDBACK_CATEGORIES.error(),
    payload: error
  });

  dispatch(requestFetchFeedbackCategories());

  return settingsApi.fetchFeedbackCategories(token).then(({ data }) => dispatch(
    receivedFeedbackCategories(data)
  )).catch(error => dispatch(errorOnFetchFeedbackCategories(error)));
};

export const sendFeedback = ( token, params ) => dispatch => {
  const requestSendFeedback = () => ({
    type: SEND_FEEDBACK.request()
  });

  const receivedMessageFromFeedback = message => ({
    type: SEND_FEEDBACK.success(),
    payload: message
  });

  const errorOnSendFeedback = error => ({
    type: SEND_FEEDBACK.error(),
    payload: error
  });

  dispatch(requestSendFeedback());

  return settingsApi.sendFeedback(token, params).then(({ message }) => dispatch(
    receivedMessageFromFeedback(message)
  )).catch(error => dispatch(errorOnSendFeedback(error)));
};
